import { createFileRoute } from "@tanstack/react-router";
import { GerenciadorAnexacaoPage } from "@/pages/GerenciadorAnexacaoPage";

export const Route = createFileRoute("/gerenciador-anexacao/")({
  head: () => ({ meta: [{ title: "Gerenciador de anexação — AXIS Comprovantes" }] }),
  component: () => <GerenciadorAnexacaoPage />,
});
